import React from 'react';
import { Empty } from 'antd'; // Make sure to import Empty from Ant Design

const NoDataComponent = () => {
  return (
    <div
    style={{
        display: 'flex',
        justifyContent: 'center', // Centers horizontally
        alignItems: 'center',     // Centers vertically
        minHeight: '300px',       // Give it some height to see vertical centering
        // width: '100%',            // Take full width
        // border: '1px dashed #e0e0e0', // Optional: for visual debugging
      }}
    >

      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}  description="No data found"  />
    </div>
  );
};

export default NoDataComponent;